interface OneTrustConfigBase {
    enabled?: boolean;
}

export interface OneTrustConfigWeb extends OneTrustConfigBase {
    scriptUrl?: string;
    domainScript?: string;
}

export interface OneTrustConfigMobile extends OneTrustConfigBase {
    appId?: string;
    storageLocation?: string;
    languageCode?: string;
}

export interface OneTrustConsent {
    doNotTrack: boolean | null;
    limitAdvertisementTracking: boolean | null;
    tcfConsentString: string | null;
    gppConsentString?: string | null;
    gppSectionId?: string | null;
}

export type OneTrustConfig = OneTrustConfigBase | OneTrustConfigWeb | OneTrustConfigMobile;

export type ConsentWatcher = () => void;

export interface IOneTrustBase {
    init: (config?: OneTrustConfig) => Promise<unknown>;
    showPreferenceModal: () => void;
    getConsentStatus: () => Promise<OneTrustConsent>;
    watchConsentStatus: (callback: ConsentWatcher) => () => void;
}

export interface IOneTrustMobile extends IOneTrustBase {
    checkAndShowBanner: () => void;
}

export interface IOneTrustWeb extends IOneTrustBase {
    loadOneTrustScript: (url: string, domainScript: string) => void;
}

export type IOneTrustInstance = IOneTrustBase | IOneTrustMobile | IOneTrustWeb;

export const consentCategories: string[] = ['V2STACK42', 'C0004'];
